import { CSSProperties, useRef } from 'react';
import { AllieAvatar, AllieSelect } from '../../../components';
import { AllieEllipsedText } from '../EllipsedText';
import { StyledUserAssignedContainer } from './UserAssigned.styles';

export interface UserAssignedType {
  avatar?: string;
  name?: string;
  size?: number;
  operators?: any[];
  onSelect?: (e: CustomEvent) => Promise<unknown>;
  selected?: number;
  textSizeRatio?: number;
  selectProps?: CSSProperties;
  width?: number | string;
  nameMaxWidth?: number | string;
  onlyAvatar?: boolean;
  hideOnEmpty?: boolean;
}

const namespace = 'responsable';

export const AllieUserAssigned = 
  ({
    avatar,
    name,
    size = 30,
    textSizeRatio,
    operators,
    onSelect,
    selected,
    selectProps = {},
    width,
    nameMaxWidth,
    onlyAvatar = false,
    hideOnEmpty = false,
  }: UserAssignedType) => {
    const usersRef = useRef<HTMLIonSelectElement>(null);
    const defaultValue = selected || operators?.[0].value;

    const onChange = (e: CustomEvent) => {
      if (onSelect) {
        onSelect(e)
        .catch(() => {
          usersRef.current?.setAttribute('programatic', 'true');
          usersRef.current?.setAttribute('value', defaultValue);
          usersRef.current?.removeAttribute('programatic');
        })
      };
    }

    return (
      <StyledUserAssignedContainer style={{ width: `${operators && !width ? '100%' : width}` }}>
        {
          name && !operators ? (
            <>
              <AllieAvatar
                className={`${namespace}__avatar`}
                height={size}
                src={avatar}
                name={name}
                textSizeRatio={textSizeRatio}
              />
              {
                !onlyAvatar && (
                  <AllieEllipsedText
                    value={name}
                    triggerId={`user-assigned-${new Date().getTime()}`}
                    maxWidth={nameMaxWidth}
                    width={nameMaxWidth}
                    triggerAction={'hover'}
                  />
                )
              }
            </>
          ) : (
            operators ? (
              <AllieSelect
                options={operators}
                onChange={onChange}
                selected={defaultValue}
                ref={usersRef}
                slot="end"
                style={{ ...selectProps }}
              />
            ) : !hideOnEmpty && <div style={{ paddingLeft: 15 }}>{'-'}</div>
          )
        }
      </StyledUserAssignedContainer>
    )
  };
